export const ROW_TYPE = 'row';
export const LIST_TYPE = 'list';



/** WEBPACK FOOTER **
 ** ./src/types.js
 **/